import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Button } from "../../../button/src";
import { __ } from "../../../i18n/src";
import { SocialButton } from "../../../social-button/src";
import { Logo } from './Logo';
export const CoverPicture = ({ coverPictureUrl, groupName, isMobile, isTablet, logoUrl, onManageGroupClick, socials, }) => (_jsx(PictureRoot, { "$coverPictureUrl": coverPictureUrl, "$isMobile": isMobile, "$isTablet": isTablet, "data-testid": "group-header-cover-picture", children: _jsxs(Box, { alignItems: "flex-end", justifyContent: "space-between", pb: 2, pl: 4, pr: {
            _: 3,
            m: 5,
            l: 2,
        }, width: "100%", children: [_jsxs(Box, { alignItems: "flex-end", children: [logoUrl && (_jsx(Box, { mr: 4, children: _jsx(Logo, { groupName: groupName, logoUrl: logoUrl }) })), onManageGroupClick && (_jsx(Button, { onClick: onManageGroupClick, variant: "inversed", children: __('Manage group') }))] }), _jsx(SocialButtonsWrapper, { children: socials === null || socials === void 0 ? void 0 : socials.map((social) => (_jsx(Box, { ml: 2, children: _jsx(SocialButton, { title: social.title, type: social.type, url: social.url }) }, social.type))) })] }) }));
export default CoverPicture;
const PictureRoot = styled(Box).attrs(({ $isMobile, $isTablet }) => ({
    height: { xl: 313, l: 217, m: 'auto' },
    width: $isMobile || $isTablet ? '100vw' : '100%',
})) `
  background-image: ${({ $coverPictureUrl }) => `url(${$coverPictureUrl})`};
  background-position: center;
  background-size: cover;

  aspect-ratio: ${({ $isMobile, $isTablet }) => $isTablet ? '1143/260' : $isMobile ? '757/418' : 'auto'};

  ${({ theme }) => `
    @media (min-width: ${theme.breakpoints.l}) {
      border-radius: ${theme.themeVariables.globalBorderRadius}px;
    }
  `}
`;
const SocialButtonsWrapper = styled(Box).attrs(() => ({
    flexWrap: 'wrap',
})) `
  row-gap: 8px;
`;
//# sourceMappingURL=CoverPicture.js.map